module.exports = __webpack_public_path__ + "static/img/clients-bg.d32efc5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/clients-bg.jpg
// module id = 9WkW
// module chunks = 1